import * as yup from 'yup';

export const CreateEditSchoolBankConfigFormValidation = yup.object().shape({
  bankEntity: yup.string().required('Entidade bancária é obrigatório'),
  status: yup.boolean().required('Estado é obrigatório'),
});